import React from "react";

import SearchForm from "./SearchForm";

export default function Introduction() {
  return (
    <div className="introduction">
      <h1 className="introduction-title">Online Bus Ticket Booking </h1>
      <SearchForm />
      <h2></h2>
    </div>
  );
}
